import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=d97783b4&scoped=true"
import script from "./Vessel.vue?vue&type=script&lang=js"
export * from "./Vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97783b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d97783b4')) {
      api.createRecord('d97783b4', component.options)
    } else {
      api.reload('d97783b4', component.options)
    }
    module.hot.accept("./Vessel.vue?vue&type=template&id=d97783b4&scoped=true", function () {
      api.rerender('d97783b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/Vessel.vue"
export default component.exports